import styled from 'styled-components';
import { Checkbox, InputRef } from 'antd';
import { useTranslation } from 'react-i18next';
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { Dispatch, RefObject, SetStateAction, useState } from 'react';
import { AreaTreeSelect } from './AreaTreeSelect';
import { SpecialtyTreeSelect } from './SpecialtyTreeSelect';
import useTypeAheadSearch from '../../hooks/useTypeAheadSearch';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 16px;
  align-items: center;
  margin-top: 1rem;
`;

interface FiltersProps {
  specialtyValue: string[] | undefined;
  handleOnSpecialtyChange: Dispatch<SetStateAction<string[]>>;
  districtValue: string[] | undefined;
  handleOnDistrictChange: Dispatch<SetStateAction<string[] | undefined>>;
  handleOnAreaChange: (value: string) => void;
  handleOnSearchQueryChange: (value: string) => void;
  showDistrict?: boolean;
  showSpecialty: boolean;
  onlyGeneralPractitioner?: boolean | null;
  inputEl: RefObject<InputRef>;
}

const Filters = ({
  specialtyValue,
  handleOnSpecialtyChange,
  districtValue,
  handleOnDistrictChange,
  handleOnAreaChange,
  handleOnSearchQueryChange,
  showSpecialty = true,
  showDistrict = true,
  onlyGeneralPractitioner = null,
  inputEl,
}: FiltersProps) => {
  const { t } = useTranslation();
  const [isChecked, setIsChecked] = useState(onlyGeneralPractitioner ?? false);
  useTypeAheadSearch(inputEl, handleOnSearchQueryChange);

  const handleOnCheckbox = (e: CheckboxChangeEvent) => {
    e.target.checked ? handleOnSpecialtyChange(['General Practitioner'.toUpperCase()]) : handleOnSpecialtyChange([]);
    setIsChecked(e.target.checked);
  };

  return (
    <Wrapper>
      {/*<Input.Search placeholder="Search here" defaultValue={''} ref={inputEl} />*/}
      {showDistrict && (
        <AreaTreeSelect
          handleOnAreaChange={handleOnAreaChange}
          handleOnDistrictChange={handleOnDistrictChange}
          districtValue={districtValue}
        />
      )}
      {showSpecialty && (
        <SpecialtyTreeSelect
          handleOnSpecialtyChange={handleOnSpecialtyChange}
          specialtyValues={specialtyValue}
          isChecked={isChecked}
        />
      )}
      {onlyGeneralPractitioner !== null && (
        <Checkbox checked={isChecked} onChange={handleOnCheckbox}>
          {t('panelList.defaultSpecialtyCheckbox')}
        </Checkbox>
      )}
    </Wrapper>
  );
};

export default Filters;
